export default "__VITE_ASSET__DKoMkqRd__"